const en = {
  // Operation
  addProduct: "Add product",

  code: "Inventory code",
  name: "Inventory name",
  uom: "UOM",
  cbm: "Cubic meter",
  brand1: "Model 1",
  brand2: "Model 2",

  // Form
  plCode: "Please enter the inventory code",
  plCodeRule: "The inventory code length is at least {{min}} digits and at most {{max}} digits.",
  plName: "Please enter the inventory name",
  plInputMaxRule: "The inventory name cannot exceed {{length}} characters.",
  plCbm: "Please enter cubic meters",
  plDesc: "Please enter a description",
  plBrand1: "Please enter the model 1",
  plBrand2: "Please enter the model 2",
  plUom: "Please select the primary unit of measurement",

  category: "Category",
  addFailed: "Add failed",
  modifySuccess: "Modify successfully",
  modifyFailed: "Modify failed",
  addChildNode: "Add child node",
  clickModify: "Click to modify",
  serialNum: "Serial number",
  addCategory: "Add category",
  addType: "Add product type",
  selProduct: "Please select product",
  priPrducInfo: "Print product information",
  priThisPage: "Print the content of this page",
  modify: "Modify",
  plFill: "Please fill in the required items!",
  modifyProduct: "Modify product",
  process: "Process",
  processPl: "Please select the process",
  materialProcess: "Material Process",
  cbmDecimalLength: "The number of decimal places cannot exceed {{count}}",

  gallery: 'Gallery',
  folder: 'Folder',
  dataError: 'Data error, please contact the administrator to modify the information and try again',
  productInfo: ' Product Information',
  num: ' Inventory quantity ',
  model: ' Inventory model ',
  preReady: 'Regular items',
  isTrue: 'Yes',
  isFalse: 'No',
  isDeprecated: 'Deprecated',
  deprecated: 'Deprecated',
  normalStatus: 'Normal',
  notSet: 'Not Set',
  returnQuantity: "Return Quantity",
  noReturnQuantity: "No returned goods",

  // Product Info
  createProductInfo: "Create Product Info",
  editProductInfo: "Edit Product Info",
  viewProductInfo: "View Product Info",
  selectSaleOrder: "Select Sale Order",
  orderNumber: "Order Number",
  erpCode: "ERP Code",
  issueDate: "Issue Date",
  customerName: "Customer Name",
  customerModel: "Customer Model",
  companyModel: "Company Model",
  productionSoftware: "Production Software",
  flash: "Flash Software",
  md5Value: "MD5 Value",
  checksum: "Checksum",
  qaToolVersion: "QA Tool Version",
  softwareVersion: "Software Version",
  macAddressContent: "MAC Address Content",
  quantity: "Quantity",
  size: "Size",
  antivirusStatus: "Antivirus Status",
  languageRequirement: "Language Requirement",
  ssid: "SSID",
  initialIp: "Initial IP",
  finishedToolVersion: "Finished Tool Version",
  semiFinishedToolVersion: "Semi-Finished Tool Version",
  channelRange: "Channel Range",
  channelSelection: "Channel Selection",
  defaultChannel: "Default Channel",
  functionDescription: "Function Description",
  productionTestProgram: "Production Test Program",
  power: "Power",
  evm: "EVM",
  fer: "FER",
  smt: "SMT",
  dip: "DIP",
  test1: "Test 1",
  assy: "Assembly",
  test2: "Test 2",
  pack: "Pack",
  shipmentRequirements: "Shipment Requirements",
  plSelectSaleOrder: "Please select sale order",
  attachments: "Attachment Images",
  uploadImage: "Upload Image",
  plUploadImage: "Please upload an image",
  uploadFailed: "Upload failed",
  imageSelected: "Image selected",
  onlyImageAllowed: "Only image uploads are allowed",
  clickOrDragUpload: "Click or drag file to this area to upload",
  descriptionPlaceholder: "Description (optional)",
  addAttachment: "Add Attachment Image",
  languageZh: "Chinese",
  languageEn: "English",
  languageTr: "Traditional Chinese",
  languageVn: "Vietnamese",
  languageKo: "Korean",
  languageFr: "French",
  languageDe: "German",
  languageRu: "Russian",
  languageAdaptive: "Adaptive",
  languagePortuguese: "Portuguese, Others",
  region36to165: "Region 36-165",
  basicInfo: "Basic Info",
  productionInfo: "Production Info",
  testInfo: "Test Info",
  shipmentInfo: "Shipment Info",
  delete: "Delete",
  basicInfoDesc: "Basic Info Description",
  testProgram: "Test Program",
  testProgramFinished: "Test Program - Finished Tool Version",
  testProgramSemiFinished: "Test Program - Semi-Finished Tool Version",
  auto: "Auto",
  addSuccess: "Created Successfully",
  addSuccessDesc: "Product info has been created successfully",
  editSuccess: "Updated Successfully",
  editSuccessDesc: "Product info has been updated successfully",
  editFailed: "Update Failed",
  saleOrderAlreadyHasProductInfo: "Sales Order No.: {{orderNumber}} has already created product info",

  // List Page
  normalTab: "Normal",
  disabledTab: "Disabled",
  salesOrderNumber: "Sales Order Number",
  internalNumber: "Internal Number",
  createdAt: "Created At",
  updatedAt: "Updated At",
  action: "Action",
  disable: "Disable",
  enable: "Enable",
  disableConfirm: "Disable Confirm",
  enableConfirm: "Enable Confirm",
  disableConfirmDesc: "Are you sure you want to disable this product info?",
  enableConfirmDesc: "Are you sure you want to enable this product info?",
  disableSuccess: "Disabled Successfully",
  enableSuccess: "Enabled Successfully",
  disableFailed: "Disable Failed",
  enableFailed: "Enable Failed",
  searchPlaceholder: "Please enter product ID or manual name to search",
  batchExport: "Batch Export",
  minStockCount: "Min Stock",
  maxStockCount: "Max Stock",
  minStockAgeDays: "Min Stock Age (Days)",
  maxStockAgeDays: "Max Stock Age (Days)",
  codePl: "Enter Material Code",
  alertAdd: "Add Alert",
  alertDetail: "Alert Details",
  overMaxCount: "Exceeds max stock: {{maxStockCount}}",
  lowerMinCount: "Below min stock: {{minStockCount}}",
  alert: "Alert",
  hh: "Constant Humidity",
  ht: "Constant Temperature",
  va: "Vacuum",
  ot: "Other",
  storeType: "Storage Requirement",
  storageCode: "Requirement Type",
  minValue: "Lower Limit",
  maxValue: "Upper Limit",
  unit: "Unit",
  inspectionCycleDays: "Inspection Cycle (Days)",
};

export default en;
